import {Routes, RouterModule} from '@angular/router';
import {ModuleWithProviders} from '@angular/core';

const appRoutes: Routes = [
  {
    path: '',
    loadChildren: './user/user.module#UserModule'
  }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes,{ useHash: true });




// WEBPACK FOOTER //
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/app.routes.ts